import { createServerOnlyFn } from "@tanstack/react-start";

import {
    getAuth,
    handleAuthorizationServerMetadataRequest,
} from "@/lib/core/auth-protocol.server";

const handleViewerIdentityAuth = createServerOnlyFn(
    async (request: Request) => {
        return (await getAuth()).handler(request);
    },
);

export const viewerIdentityAuthRoute = {
    server: {
        handlers: {
            GET: ({ request }: { request: Request }) =>
                handleViewerIdentityAuth(request),
            POST: ({ request }: { request: Request }) =>
                handleViewerIdentityAuth(request),
        },
    },
};

const handleAuthorizationServerMetadata = createServerOnlyFn(
    (request: Request) => handleAuthorizationServerMetadataRequest(request),
);

export const authorizationServerMetadataRoute = {
    server: {
        handlers: {
            GET: ({ request }: { request: Request }) =>
                handleAuthorizationServerMetadata(request),
        },
    },
};
